import { Star, Quote } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { useData } from '../contexts/DataContext';

export default function Testimonials() {
  const { testimonials, loading } = useData();
  const { t } = useLang();

  if (loading || testimonials.length === 0) return null;

  return (
    <section className="py-24 bg-[#0A192F]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-cyan-400 text-sm uppercase tracking-[0.2em] mb-4 font-semibold">{t('test_label')}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-6">
            {t('test_title_1')} <span className="gradient-text">{t('test_title_2')}</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{t('test_desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={testimonial.id} className="premium-card p-8 card-hover relative" data-testid={`testimonial-card-${index}`}>
              <div className="absolute top-6 right-6 text-cyan-500/20">
                <Quote className="w-12 h-12" />
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`w-5 h-5 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-slate-600'}`} />
                ))}
              </div>
              <p className="text-slate-300 mb-6 leading-relaxed italic">"{testimonial.text}"</p>
              <div className="flex items-center gap-4">
                {testimonial.image_url && (
                  <img src={testimonial.image_url} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-cyan-500/30" />
                )}
                <div>
                  <p className="font-semibold text-white">{testimonial.name}</p>
                  <p className="text-sm text-slate-500">{t('test_verified')}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-wrap justify-center items-center gap-8">
          <div className="flex items-center gap-2">
            <div className="flex">
              {[1,2,3,4,5].map((i) => (
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="text-white font-semibold">5.0</span>
            <span className="text-slate-400">{t('test_avg')}</span>
          </div>
          <div className="h-8 w-px bg-slate-700 hidden md:block" />
          <div className="text-slate-400">
            <span className="text-white font-semibold">500+</span> {t('test_happy')}
          </div>
          <div className="h-8 w-px bg-slate-700 hidden md:block" />
          <div className="text-slate-400">
            <span className="text-white font-semibold">1000+</span> {t('test_trips')}
          </div>
        </div>
      </div>
    </section>
  );
}
